
// Photos in the "Our Gallery" section.
// Add photos to public/photos/gallery/ and list them here.

export const galleryPhotos = [
  {
    src: "/photos/gallery/gallery-01.png",
    alt: "Child receiving a certificate with teachers on Annual Day",
  },
  {
    src: "/photos/gallery/gallery-02.png",
    alt: "Children playing with colourful balls",
  },
  {
    src: "/photos/gallery/gallery-03.png",
    alt: "Children lined up on the school sports court",
  },
  {
    src: "/photos/gallery/gallery-04.png",
    alt: "Teachers and staff seated on stage at Annual Day",
  },
  {
    src: "/photos/gallery/gallery-05.png",
    alt: "Children smiling on a field trip bus",
  },
  {
    src: "/photos/gallery/gallery-06.png",
    alt: "Teachers in matching sarees at the Annual Day celebration",
  },
  {
    src: "/photos/gallery/gallery-07.png",
    alt: "Children in pink uniforms on a field trip",
  },
  {
    src: "/photos/gallery/gallery-08.png",
    alt: "Children and parents at a festival celebration",
  },
  {
    src: "/photos/gallery/gallery-09.png",
    alt: "Children in costume at the Annual Day celebration",
  },
  {
    src: "/photos/gallery/gallery-10.png",
    alt: "Children enjoying a school activity",
  },
  {
    src: "/photos/gallery/gallery-11.png",
    alt: "Children playing together",
  },
  {
    src: "/photos/gallery/gallery-12.png",
    alt: "Children participating in classroom activities",
  },
  {
    src: "/photos/gallery/gallery-13.png",
    alt: "Children learning through play",
  },
  {
    src: "/photos/gallery/gallery-14.png",
    alt: "Children enjoying outdoor activities",
  },
  {
    src: "/photos/gallery/gallery-15.png",
    alt: "Children participating in a school event",
  },
];
